export const company = {
  name: "Liv Themes",
  nameShort: "Liv"
};
